'use client';

import Image from 'next/image';
import Link from 'next/link';
import { ShoppingCart } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useOrderStore } from '@/store/order-store';
import { formatPrice } from '@/lib/utils';

interface ProductCardProps {
  id: string;
  slug: string;
  name: string;
  brandName: string;
  brandSlug: string;
  price: number;
  showPrice: boolean;
  imageUrl: string;
  badgeType?: 'samsung' | 'apple' | 'xiaomi' | 'huawei' | 'default';
  variantId?: string;
  variantName?: string;
  variant?: 'compact' | 'full';
  onAddedToCart?: () => void;
}

export function ProductCard({
  id,
  slug,
  name,
  brandName,
  price,
  showPrice,
  imageUrl,
  variantId = 'default',
  variantName = '',
  variant = 'compact',
  onAddedToCart,
}: ProductCardProps) {
  const addItem = useOrderStore((state) => state.addItem);

  const handleAddToOrder = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    addItem({
      productId: id,
      variantId,
      productName: name,
      variantName,
      price,
      showPrice,
      imageUrl,
    });
    if (onAddedToCart) {
      onAddedToCart();
    }
  };

  return (
    <Link href={`/products/${slug}`} className="group block  ">
      {/* <Card className="h-full pt-0 transition-all duration-300 group-hover:-translate-y-1 group-hover:ring-primary/40"> */}
        {/* <div className="relative aspect-square w-full overflow-hidden bg-muted pt-(--card-spacing)"> */}
      <Card className="h-full pt-0 rounded-sm transition-all  duration-300 group-hover:-translate-y-1   ring-0 shadow-sm group-hover:shadow-lg outline-none border-none ">
        <div className="relative aspect-square w-full overflow-hidden ">
          <div className="relative h-full w-full  transition-transform duration-300 group-hover:scale-105">
            <Image
              src={imageUrl || '/products/galaxy-s24-ultra.svg'}
              alt={name}
              fill
              className="object-contain "
              sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw"
              priority={false}
              unoptimized
            />
          </div>
          <span className="absolute bottom-3 inset-s-3 z-10 inline-block rounded-full bg-primary px-2.5 py-0.5 text-[11px] font-bold tracking-wide text-primary-foreground uppercase shadow-md">
            {brandName}
          </span>
        </div>

        <CardContent className="flex flex-col justify-between gap-3">
          <div>
            <h3 className="line-clamp-1 text-base font-bold transition-colors group-hover:text-primary">
              {name}
            </h3>

            <div className="mt-2 flex items-baseline gap-1.5">
              {showPrice ? (
                <>
                  <span className="text-xl font-extrabold tracking-tight text-primary">
                    {formatPrice(price)}
                  </span>
                  <span className="text-xs font-bold text-muted-foreground">DA</span>
                </>
              ) : (
                <span className="text-sm text-muted-foreground">السعر عند الطلب</span>
              )}
            </div>
          </div>

          {variant === 'compact' ? (
            <div className="flex justify-end">
              <Button type="button" size="icon" onClick={handleAddToOrder} title="أضف للطلب">
                <ShoppingCart />
              </Button>
            </div>
          ) : (
            <Button type="button" className="w-full gap-2" onClick={handleAddToOrder}>
              <ShoppingCart />
              <span>إضافة إلى الطلبات</span>
            </Button>
          )}
        </CardContent>
      </Card>
    </Link>
  );
}
